module.exports = __webpack_public_path__ + "media/images/icons/country_flags/dm-a87ef3072bee60985f03ad1c86503c7d.svg";